/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SimpleUser } from './simple-user';
import { DeckPitchSelfPublishDetailStatusEnum } from './deck-pitch-self-publish-detail-status-enum';
import { DealflowFile } from './dealflow-file';
import { DeckSelfPublishFile } from './deck-self-publish-file';

export interface DeckPitchSelfPublishDetail {
  readonly id: string;
  readonly pitch_id: string;
  readonly pitch_name: string;
  readonly company_name: string | null;
  readonly company_id: string | null;
  readonly status: DeckPitchSelfPublishDetailStatusEnum;
  readonly paid: boolean;
  readonly accepted: boolean;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly modified_date: string;
  readonly signed_kyp1: string;
  readonly seal: string | null;
  readonly ppcl: number | null;
  readonly files: Array<DeckSelfPublishFile>;
  readonly representatives: Array<SimpleUser>;
  readonly dealflow_files: Array<DealflowFile>;
  readonly response_id: string;
}
export namespace DeckPitchSelfPublishDetail {}
